const slideIcon = () => {
    $('.service-slide-icon-slick').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        let title = $(slick.$slides[nextSlide]).data("title")
        const $textBox = $(this).parents(".slide-icon-wrap").find(".whitebox-content")
        $textBox.fadeOut(function () {
            $textBox.html(title)
        }).fadeIn();
    });
    $('.service-slide-icon-slick').on('init', function (event, slick) {
        let title = $(slick.$slides[0]).data("title")
        const $textBox = $(this).parents(".slide-icon-wrap").find(".whitebox-content")
        $textBox.fadeOut(function () {
            $textBox.html(title)
        }).fadeIn();
    });

    $(".service-slide-icon-slick").slick({
        dots: true,
        infinite: true,
        speed: 500,
        cssEase: 'linear',
        autoplay: false,
        autoplaySpeed: 5000,
        centerMode: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        customPaging: function (slider, index) {
            return `<div class="page-item">${index + 1}</div>`
        }
    });

}

module.exports = slideIcon